import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';

const MailAccountPage = () => {
  const navigate = useNavigate();

  return (
    <div className="px-6 py-8 max-w-2xl">
      <h1 className="text-xl font-medium text-gray-900 dark:text-white mb-2">Microsoft hesabı</h1>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
        E-posta özeti ve gelen kutusu listesi için Microsoft 365 hesabınıza uygulama izni vermeniz gerekir.
        Oturum tarayıcıda MSAL önbelleğinde saklanır; kurumsal ilkelere göre paylaşılan bir bilgisayarda
        oturumu kapatmayı unutmayın.
      </p>
      <div className="flex flex-wrap gap-3">
        <Button
          type="button"
          className="bg-blue-600 hover:bg-blue-700 text-white"
          onClick={() => navigate('/login/microsoft')}
        >
          Microsoft ile giriş
        </Button>
        <Button type="button" variant="outline" onClick={() => navigate('/mail/summary')}>
          AI özet sayfasına dön
        </Button>
      </div>
    </div>
  );
};

export default MailAccountPage;
